import module from 'guest/module.js'
import template from './template.html'
import moment from 'moment'

class GuestInformacionSatEnviardeduccionesComponent {
  constructor (dialog, $dialogParams, $documentos, $file, $notify, GuestInformacionSatDeducciones) {
    this.dialog = dialog
    this.$dialogParams = $dialogParams
    this.$documentos = $documentos
    this.$file = $file
    this.$notify = $notify
    this.GuestInformacionSatDeducciones = GuestInformacionSatDeducciones
    this.comprimido = undefined
    this.enviando = false
    this.uid = `${this.options.ID_Empleado}@${this.options.ID_Empresa}`
    this.options = {
      files: [],
      filename: 'Deducciones 2015.zip',
      ID_Empleado: this.$dialogParams['ID_Empleado'],
      ID_Empresa: this.$dialogParams['ID_Empresa'],
    }
  }

  agregar () {
    this.comprimido = undefined

    this.$file.select(true).then((files) => (this.options.files = this.options.files.concat(files)))
  }

  eliminar (file) {
    this.options.files.splice(this.options.files.indexOf(file), 1)
  }

  cancelar () {
    this.dialog.reject()
  }

  comprimir () {
    this.comprimido = false

    const filename = `Deducciones 2015 - ${moment().format('YYYY-MM-DD HH:mm:ss')}.zip`

    return this.$file.zip(this.options.files, filename)
      .finally(() => (this.comprimido = true))
  }

  enviar (file) {
    this.enviando = true

    return this.$documentos.$insert(this.uid, file, 'SAT_DEDUCCIONES')
      .then((documento) => {
        return {
          id_empleado: this.options.ID_Empleado,
          id_empresa: this.options.ID_Empresa,
          Tipo: '001',
          Ejercicio: '2015',
          Periodo: '',
          ID_Documento: documento['Archivo_ID'],
          Contenido: this.options.files.join(','),
        }
      })
      .then((data) => this.GuestInformacionSatDeducciones.post(data))
      .then(() => this.dialog.resolve())
      .catch((error) => (this.$notify.error(error)))
      .finally(() => (this.enviando = false))
  }
}

module.controller('GuestInformacionSatEnviardeduccionesComponent', GuestInformacionSatEnviardeduccionesComponent)
module.config(($dialogProvider) => {
  $dialogProvider.dialog('guestInformacionSatEnviardeducciones', {
    controller: 'GuestInformacionSatEnviardeduccionesComponent',
    template,
    controllerAs: '$ctrl',
  })
})



// WEBPACK FOOTER //
// ./src/guest/components/informacion/sat/enviardeducciones/component.js